





















































































































import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class OrbitRemoveOwnerConfirmStep extends Vue {
  @Prop({type: String, default: ''}) ownerAddress!: string

  onConfirm() {
    this.$emit('confirm')
  }

  onCancel() {
    this.$emit('cancel')
  }
}
